// extracted by mini-css-extract-plugin
export default {"container":"Qq9p0F","title":"tQFwnj","textButton":"IqzMYA"};